export async function apiRequest(endpoint, options = {}) {
  const url = `${process.env.REACT_APP_API_BASE_URL}${endpoint}`;
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  const config = {
    headers: { ...defaultHeaders, ...options.headers },
    method: options.method || 'GET',
    body: options.body ? JSON.stringify(options.body) : undefined,
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API error ${response.status}: ${errorText}`);
    }

    // Try to parse JSON, fallback to text
    const contentType = response.headers.get('content-type');
    return contentType && contentType.includes('application/json')
      ? response.json()
      : response.text();
  } catch (err) {
    console.error(`Error calling ${url}`, err);
    throw err;
  }
}